export default {"src":"/_next/static/media/InboxFilled.4113669d.svg","height":37,"width":41,"blurWidth":0,"blurHeight":0};